// Catches typos like "gmail.con" or "hotmial.com" in the domains Swedish visitors use most.
const COMMON_DOMAINS = [
  'gmail.com',
  'hotmail.com',
  'hotmail.se',
  'outlook.com',
  'outlook.se',
  'live.se',
  'live.com',
  'msn.com',
  'icloud.com',
  'me.com',
  'yahoo.com',
  'yahoo.se',
  'telia.com',
  'bredband.net',
  'spray.se',
  'comhem.se',
  'bahnhof.se',
];

const MAX_DISTANCE = 2;

function levenshtein(a: string, b: string): number {
  let previous = Array.from({ length: b.length + 1 }, (_, i) => i);
  for (let i = 1; i <= a.length; i++) {
    const current = [i];
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      current[j] = Math.min(previous[j] + 1, current[j - 1] + 1, previous[j - 1] + cost);
    }
    previous = current;
  }
  return previous[b.length];
}

// Returns the corrected address, or null when the domain looks fine or is too different to guess.
export function suggestEmail(email: string): string | null {
  const trimmed = email.trim().toLowerCase();
  const at = trimmed.lastIndexOf('@');
  if (at < 1 || at === trimmed.length - 1) return null;

  const domain = trimmed.slice(at + 1);
  if (COMMON_DOMAINS.includes(domain)) return null;

  let best: string | null = null;
  let bestDistance = MAX_DISTANCE + 1;
  for (const candidate of COMMON_DOMAINS) {
    const distance = levenshtein(domain, candidate);
    if (distance < bestDistance) {
      best = candidate;
      bestDistance = distance;
    }
  }
  return best ? `${trimmed.slice(0, at)}@${best}` : null;
}
